import { render } from "./FinalizadoresView.vue?vue&type=template&id=43f8757a&ts=true"
import script from "./FinalizadoresView.vue?vue&type=script&lang=ts"
export * from "./FinalizadoresView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__